import { render } from "./SustainabilityView.vue?vue&type=template&id=0631c4f0&scoped=true"
import script from "./SustainabilityView.vue?vue&type=script&lang=js"
export * from "./SustainabilityView.vue?vue&type=script&lang=js"

import "@/assets/css/about.css?vue&type=style&index=0&id=0631c4f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0631c4f0"]])

export default __exports__